export default {
    data() {
        return {
            isEdit: false,
            isNew: false,
            isDetails: false,
            loading: true		// 页面加载
        }
    },
    created() {
        const route = this.$route
        if (route.params.id || route.query.id) {
            if (route.params.id) {
                this.isDetails = true
            }
            if (route.query.id) {
                this.isEdit = true
            }
        } else {
            this.isNew = true
            this.loading = false
        }
    },
    activated() {
        const route = this.$route
        if (route.params.id || route.query.id) {
            if (route.params.id) {
                this.isDetails = true
            }
            if (route.query.id) {
                this.isEdit = true
            }
        } else {
            this.isNew = true
            this.loading = false
        }
    }
}
